module.exports = __webpack_public_path__ + "f1da05c6b2702b856ff8affd0138cbea.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/secure-graphics.png
// module id = 2306
// module chunks = 1